<template>
    <div>
        <comp-title-dc back-url-name="acctManager" :back-url-query="{ activeIndex: '2' }">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager' }">账户管理</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/acctManager?activeIndex=2' }">
                    账户安全
                </el-breadcrumb-item>
                <el-breadcrumb-item>登录信息查询</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="info-box bizcomp-border">
            <div class="top-title">登录信息查询</div>
            <div>
                <div class="filter-box">
                    <div class="filter-block">
                        <span>登录日期：</span>
                        <date-picker
                            :date="dateSet"
                            sep-text="-"
                            style="width: 310px"
                            clearable
                            v-on:date-get="dateInterval"
                        />
                    </div>
                    <el-button
                        type="primary"
                        size="small"
                        :disabled="isLoading"
                        v-on:click="queryPage()"
                    >
                        查询
                    </el-button>
                </div>
                <el-table
                    :data="dataObj.data"
                    class="tab-list-tit"
                    border
                    :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
                >
                    <template #empty>
                        <div class="no-funds">
                            <span class="no-funds-img" />
                            <div class="no-funds-box">
                                <p>暂无数据</p>
                            </div>
                        </div>
                    </template>
                    <!-- 出参字段 -->
                    <el-table-column prop="opertime_date" label="登录日期" v-bind="tableColProps" />
                    <el-table-column prop="opertime_time" label="登录时间" v-bind="tableColProps" />
                    <el-table-column
                        prop="certificatetype"
                        label="登录账号类型"
                        v-bind="tableColProps"
                        :formatter="(row, column, value) => getCertTypeName(row, value)"
                    />
                    <el-table-column
                        prop="certificateno"
                        label="登录账号"
                        v-bind="tableColProps"
                        min-width="240"
                    />
                    <el-table-column prop="ip" label="登录IP" v-bind="tableColProps" />
                    <el-table-column prop="show_area" label="登录地区" v-bind="tableColProps" />
                </el-table>
                <el-pagination
                    v-if="dataObj.total > 0"
                    layout="->, total, prev, pager, next"
                    :total="dataObj.total"
                    :current-page.sync="dataObj.pageNum"
                    :page-size="dataObj.pageSize"
                    v-on:current-change="currentChange"
                />
            </div>
            <div class="warn-tip-contain">
                <div class="warn-tip-title">温馨提示：</div>
                <div class="warn-tip-text">
                    因网络原因，可能出现系统识别出的登录地区与实际不一致，不影响您对基本业务功能的正常使用。如您发现可能存在非本人操作的登录，建议您尽快修改密码，或拨打客服热线{{
                        $cache.getCompanyInfoParam("10101009")
                    }}进行确认。
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import datePicker from "@/components/form/datePicker";
import userApi from "@/api/user";
import format from "date-fns/format";
export default {
    name: "AcctInfoLogin",
    components: {
        datePicker
    },
    mixins: [mixin],
    data() {
        return {
            // 入参
            dateSet: {
                type: "2",
                min: "1990-01-01",
                size: "mini",
                text: "开始时间",
                text2: "结束时间"
            },
            endDate: "",
            beginDate: "",
            nowDate: "",
            // 表格
            tableColProps: {
                minWidth: "120",
                align: "center",
                headerAlign: "center",
                showOverflowTooltip: true,
                formatter: (row, column, value) => value || "--"
            },
            dataObj: {
                data: [],
                total: 0,
                pageNum: 1,
                pageSize: 10
            },
            isLoading: false,
            certTypes: []
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            // 时间区间
            this.nowDate = format(new Date(), "YYYYMMDD");
            this.dateSet.max = this.$util.fmtDate(this.nowDate);
            // 证件号类型
            this.initCertTypes();
            // 查询
            this.queryPage();
        },
        // 证件号类型
        initCertTypes() {
            this.certTypes = JSON.parse(JSON.stringify(this.$cache.getDict("130007"))) || [];
            this.certTypes = this.certTypes.concat([
                {
                    dictitem: "130007",
                    subitem: "000",
                    subitemname: "基金账号",
                    sysid: "4"
                }
            ]);
            let findIndex = this.certTypes.findIndex((item) => item.subitem === `00`);
            if (findIndex >= 0) {
                this.certTypes[findIndex].subitemname = `身份证`;
            }
        },
        getCertTypeName(row, val) {
            if (row.accttype === "2") {
                return "基金账号";
            } else if (row.accttype === "8") {
                return "手机号";
            } else {
                const item = this.certTypes.filter((item) => item.subitem === val)[0] || {};
                return item.subitemname || "--";
            }
        },
        // 获取用户选中时间区间
        dateInterval(val) {
            this.beginDate = this.$util.isEmpty(val.beginDate)
                ? ""
                : val.beginDate.replace(/-/g, "");
            this.endDate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        // 查询
        async queryPage() {
            this.isLoading = false;
            let list = [];
            let total = 0;
            try {
                let opertime = null;
                if (this.beginDate || this.endDate) {
                    const begin = this.beginDate ? this.beginDate + "000000" : "1970000000000";
                    const end = this.endDate ? this.endDate + "235959" : "99991231235959";
                    opertime = begin + "," + end;
                }
                const { data, code } = await userApi.qryAcctTracesLogList({
                    eventid: "/auth/remote/login",
                    opertime: opertime,
                    pageSize: this.dataObj.pageSize,
                    pageNum: this.dataObj.pageNum
                });
                if (String(code) === "0") {
                    list = data.data.map((item) => {
                        let arr = [];
                        if (item.opertime.length === 14) {
                            arr = [item.opertime.substr(0, 8), item.opertime.substr(8, 6)];
                        } else {
                            arr = item.opertime ? item.opertime.split(" ") || [] : [];
                        }
                        let date = arr.length >= 1 ? arr[0].trim() : "";
                        date = date.length === 8 ? this.$util.fmtDate(date) : date;
                        let time = arr.length >= 2 ? arr[1].trim() : "";
                        time = time.length === 6 ? this.$util.fmtTime(time) : time;
                        return {
                            ...item,
                            opertime_date: date,
                            opertime_time: time,
                            show_area: (item.province || "") + (item.city || "")
                        };
                    });
                    total = data.total;
                }
            } catch (e) {
                console.error(e);
            }
            this.dataObj = {
                data: list,
                total: total,
                pageNum: this.dataObj.pageNum,
                pageSize: this.dataObj.pageSize
            };
            this.isLoading = false;
        },
        currentChange(val) {
            this.dataObj.pageNum = val;
            this.queryPage();
        }
    }
};
</script>

<style lang="scss" scoped>
.info-box {
    padding: 0 30px 30px;
    margin-bottom: 20px;
    margin-top: 13px;
    .top-title {
        color: var(--color-primary);
        font-size: 20px;
        padding: 16px 0;
        font-weight: 500;
    }
    .filter-box {
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 16px 0;
        .filter-block {
            display: flex;
            align-items: center;
            gap: 8px;
            color: var(--color-text-primary);
        }
        .primary-btn {
            background-color: var(--color-primary);
            color: #ffffff;
            border-radius: 4px;
        }
        ::v-deep .el-input--mini .el-input__inner {
            height: 32px;
            line-height: 32px;
        }
    }
    .warn-tip-contain {
        line-height: 20px;
        .warn-tip-title {
            font-weight: bold;
            color: var(--color-text-regular);
        }
        .warn-tip-text {
            text-indent: 2em;
            margin-top: 6px;
            color: var(--color-text-accent);
        }
    }
}
</style>
